export const PHASES = [
  { value: 1, label: 'labels.onePhase' },
  { value: 3, label: 'labels.threePhase' }
];

export const MODES = [
  { value: 1, label: 'labels.simpleMode' },
  { value: 2, label: 'labels.advancedMode' }
];

export const DOOR_TYPES = [
  { value: 0, label: 'labels.transparent' },
  { value: 1, label: 'labels.opaqueDoor' }
];

/**
 * Default language to use as fallback when environment.defaultLanguage is not set.
 * This ensures consistent fallback behavior across the application.
 */
export const DEFAULT_LANGUAGE = 'nl';

/**
 * Language parameter to use in the URL.
 * This is used to pass the language to the backend.
 */
export const LANGUAGE_PARAMETER = 'lang';
